var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import GenericSlot from './GenericSlot';
import TotalOutcome from '../outcomes/TotalOutcome';
import { byIdComparator } from './slotUtils';
import { FormattedMessage, defineMessages } from 'react-intl';
import { outcomeSortFunc } from '../../../../rendering-commons/Sorting';
var messages = defineMessages({
    grid_under: {
        id: "grid.under",
        defaultMessage: "меньше"
    },
    grid_over: {
        id: "grid.over",
        defaultMessage: "больше"
    },
});
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        var _a = this.props, outcomes = _a.outcomes, gridLocalization = _a.gridLocalization, section = _a.section;
        var sectionToggled = this.state.sectionToggled;
        var sectionCls = sectionToggled ? 'section selected' : 'section';
        var renderOutcomes = [];
        var props = {
            gridLocalization: gridLocalization,
            section: section
        };
        outcomes.sort(byIdComparator).sort(outcomeSortFunc).map(function (outcome) {
            renderOutcomes.push(_jsx(TotalOutcome, __assign({ outcome: outcome }, props), outcome.get('id')));
        });
        return (_jsxs("div", __assign({ className: sectionCls }, { children: [this.renderSlotTitle(), _jsxs("div", __assign({ className: 'items toggle_content' }, { children: [_jsx("div", __assign({ className: 'item total' }, { children: _jsxs("div", __assign({ className: 'rows' }, { children: [_jsx("div", __assign({ className: 'cols' }, { children: _jsx("span", __assign({ className: 'space' }, { children: "\u00A0" })) })), _jsx("div", __assign({ className: 'cols' }, { children: _jsx("div", __assign({ className: 'sub' }, { children: _jsx(FormattedMessage, __assign({}, messages.grid_under)) })) })), _jsx("div", __assign({ className: 'cols' }, { children: _jsx("div", __assign({ className: 'sub' }, { children: _jsx(FormattedMessage, __assign({}, messages.grid_over)) })) }))] })) })), sectionToggled && renderOutcomes] }))] })));
    };
    return default_1;
}(GenericSlot));
export default default_1;



// WEBPACK FOOTER //
// ./src/components/grid/event/slots/TotalSlots.jsx